export default {
    settings_crew: "Tripulación",
    settings_unit_settings: "Configuración de la Unidad",
    settings_driver_groups: "Grupos de Conductores",
    settings_unit_groups: "Grupos de Unidades",
    settings_input_labels: "Etiquetas de Entradas",
    settings_vehicle_status: "Estado del Vehículo",
    settings_vehicle_equipment: "Equipamientos",
    settings_drivers: "Conductores",
    settings_vehicle_key_fobs: "Llaveros",
    settings_vehicle_temperature: "Temperatura",
    settings_fuel_card: "Tarjeta de Combustible",
    settings_drivers_status: "Estados de Conductor",
    settings_behavior: "Comportamiento",
    settings_work_order_types: "Tipos de Órdenes de Trabajo",
    settings_work_order_status: "Estados de las Órdenes de Trabajo",
    settings_asset_subtypes: "Subtipos de activos",
    settings_assets: "Activos",
};
